import { NumberInput, required, SelectInput, TextInput, useTranslate } from 'react-admin';
import { Box, Stack, Typography } from '@mui/material';
import { RedPacketType } from '../../../services/redpacketService';

interface FormProps {
  isCreate: boolean;
}

const InterventionForm = (props: FormProps) => {
  const { isCreate } = props;
  const t = useTranslate();

  const numberProps = {
    parse: (v: any) => (v === '' || v == null ? undefined : Number(v)),
    format: (v: any) => (v == null ? '' : v),
    inputProps: {
      inputMode: 'decimal',
      step: 'any',
      onWheel: (e: React.WheelEvent<HTMLInputElement>) => {
        (e.currentTarget as HTMLInputElement).blur();
      },
    } as const,
  } as const;

  return (
    <Stack spacing={3} gap={2}>
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        alignItems={{ xs: 'stretch', sm: 'center' }}
        spacing={2}
        mb={1}
      >
        <Typography variant="body2" sx={{ flexBasis: '25%', flexShrink: 0 }}>
          {t('module.redpacket.userId')}
        </Typography>
        <Box sx={{ flexGrow: 1 }}>
          <TextInput
            label={false}
            source="userId"
            validate={[required()]}
            placeholder={t('module.redpacket.userIdPlaceholder')}
            fullWidth
          />
        </Box>
      </Stack>

      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        alignItems={{ xs: 'stretch', sm: 'center' }}
        spacing={2}
        mb={1}
      >
        <Typography variant="body2" sx={{ flexBasis: '25%', flexShrink: 0 }}>
          {t('module.redpacket.rewardAddress')}
        </Typography>
        <Box sx={{ flexGrow: 1 }}>
          <TextInput
            label={false}
            source="walletAddress"
            validate={[required()]}
            placeholder={t('module.redpacket.rewardAddressPlaceholder')}
            fullWidth
          />
        </Box>
      </Stack>

      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        alignItems={{ xs: 'stretch', sm: 'center' }}
        spacing={2}
        mb={1}
      >
        <Typography variant="body2" sx={{ flexBasis: '25%', flexShrink: 0 }}>
          {t('module.redpacket.amount')}
        </Typography>
        <Box sx={{ flexGrow: 1 }}>
          <NumberInput label={false} source="amount" validate={[required()]} fullWidth />
        </Box>
      </Stack>

      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        alignItems={{ xs: 'stretch', sm: 'center' }}
        spacing={2}
        mb={1}
      >
        <Typography variant="body2" sx={{ flexBasis: '25%', flexShrink: 0 }}>
          {t('module.redpacket.redPacketTypeLabel')}
        </Typography>
        <Box sx={{ flexGrow: 1 }}>
          <TextInput
            label={t('module.redpacket.onlyCreatesCriticalHits')}
            source="type"
            defaultValue={RedPacketType.CRITICAL_HIT}
            disabled
          />
        </Box>
      </Stack>

      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        alignItems={{ xs: 'stretch', sm: 'center' }}
        spacing={2}
        mb={1}
      >
        <Typography variant="body2" sx={{ flexBasis: '25%', flexShrink: 0 }}>
          {t('module.redpacket.reason')}
        </Typography>
        <Box sx={{ flexGrow: 1 }}>
          <TextInput
            label={false}
            source="reason"
            validate={[required()]}
            placeholder={t('module.redpacket.reasonPlaceholder')}
            fullWidth
            multiline
            rows={3}
          />
        </Box>
      </Stack>
    </Stack>
  );
};

export default InterventionForm;
